import { buildCoverSheetConfig } from '../shared';
import { BaseOfferConfig, type OfferLocaleOverrides } from './base';
import { overrides } from './overrides';

/**
 * Builds the coversheet config for an offer.
 * @param locale Locale code, e.g. CA
 * @returns Coversheet config for specified locale
 */
export function buildOfferCoverSheetConfig(locale: string) {
  const localeOverrides: OfferLocaleOverrides = overrides[locale] ?? {
    locale,
  };
  return buildCoverSheetConfig(BaseOfferConfig, localeOverrides);
}
